// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__5uCjY","hide":"Footer_hide__x1jWg"};